export const IMAGES = {
  heroLandscape:
    "https://static.prod-images.emergentagent.com/jobs/39ea95f6-15fe-4fdc-b958-104ffb797cd8/images/f6cc1297d8f83de40e24788d16f407bdde5976917021acb1b088cd44062e49e9.png",
  earthyBg:
    "https://static.prod-images.emergentagent.com/jobs/39ea95f6-15fe-4fdc-b958-104ffb797cd8/images/d9fe1872431ba19fb597251104ac0e04a3b9ca6e9e0f7ab674928f3748f4ec01.png",
  cleanLivingRoom:
    "https://static.prod-images.emergentagent.com/jobs/39ea95f6-15fe-4fdc-b958-104ffb797cd8/images/4ffc84bf73b0630ff4f45bb3ad48c35ce64229f93d13e216b872e1eb36f128cb.png",
  cleaningCrew:
    "https://images.pexels.com/photos/6196685/pexels-photo-6196685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  landscapingModern:
    "https://images.unsplash.com/photo-1772040942277-b194d9d0b648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxsYW5kc2NhcGluZyUyMGJlYXV0aWZ1bCUyMG1vZGVybiUyMGJhY2t5YXJkfGVufDB8fHx8MTc4MDEwNzQwNXww&ixlib=rb-4.1.0&q=85",
};
